import React from 'react'
import { Space, Table, Tag,Button, Modal, Form, Input, message, Select, Spin } from 'antd';
import { Container } from 'react-bootstrap';
import { useEffect, useState} from 'react';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { RiDeleteBin5Line } from "react-icons/ri";
import styles from './styles.module.css';
import { IoMdCloseCircle } from 'react-icons/io';
// import Select from 'react-dropdown-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import Helper from '../../Utils/Helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';


const CustomerUserView = (props) => { 
    console.log("customerloca", props.customerLocations)

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [propsLoading, setProprLoading] = useState(true);
    const [pagination, setPagination] = useState({
            total: 0,
            current: 1,
            pageSize: 2,
            totalPages: 0
        });
    const [filterText, setFilterText] = useState('');
    const [addUserModalVisible, setAddUserModalVisible] = useState(false);
    const [searchEmail, setSearchEmail] = useState("")
    const [usersToAdd, setUsersToAdd] = useState([])
    const [userNotFoundAlert, setUserNotFoundAlert] = useState(false)
    const [customerLocations, setCustomerLocations] = useState([])
    const [selectedCustomerLocations, setSelectedCustomerLocations] = useState([])
    const [permissions, setPermissions] = useState([])
    const [deleteModal, setDeleteModal] =  useState(false)
    const [modalData, setModalData] = useState({})
    const [filterLocation, setFilterLocation] = useState([]);
    

    useEffect(() => {
        setProprLoading(true)
        fetchUserData();
        setUserNotFoundAlert(false)
        getCustomerLocations()
    }, []);

    useEffect(() => {
        const init = async () => {
            setProprLoading(true);
            await checkCustomerPermissions();
            setProprLoading(false);
        };
        init();
    }, []);

    const checkCustomerPermissions = async () => {
        let permissionsVar = [];

        permissionsVar = Helper.checkCustomerPermissions(props.userGroups);
        setPermissions(permissionsVar);
        console.log("permissions", permissionsVar)
    }

    const getCustomerLocations = async ()=>{
        try{
            const res = await BreathAPIs.getDashboardFilterLocations()
            console.log("customer lc", res)
            setCustomerLocations(res.data.locations.filter(loc =>{
                return loc.locationType !== "PUBLIC"
            }))
        }catch(error){
            console.log("Error in getting customer locations",error)
        }
    }

     const handleClearFilter = () => {
         setFilterLocation([])
        setFilterText('');
        fetchUserData(1, 10, true);
    };

    const fetchUserData = async (page = 1, limit = 10, withoutFilter = false) => {
        try {
            setLoading(true)
            setUsers([])
            let res = withoutFilter ? await BreathAPIs.getCustomerUsers(1, 10) : await BreathAPIs.getCustomerUsers(page, limit, filterText ? filterText : null, filterLocation?filterLocation:null);
            console.log("User Data: ", res);
            setUsers(res.data.users?.filter(
                (user)=>{
                    return props.userId.toString() !== user._id.toString()
                }
            ));
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
            setLoading(false);
        } catch (error) {
            console.log("error in getting user data")
            setLoading(false);
        }

    }

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        fetchUserData(current, pageSize);
    };

    const removeUserLocation = async (userId, locationId) => {
        const { current, pageSize } = pagination;
        console.log("Removing location: ", userId, locationId);
        const res =  await BreathAPIs.editCusotmerUser(userId, locationId)
         await fetchUserData(current, pageSize);
        setDeleteModal(false)
    }

    const handleAddUser =  () => {
        setAddUserModalVisible(true)
    }

    const filterUser = async () => {
        setUserNotFoundAlert(false)
        console.log("searchEmail",searchEmail)
        try{
            const res = await BreathAPIs.searchUserToAdd(searchEmail);
        console.log(res)
        if (res.status === 200) {
            res.data.user.name = res.data.user.firstName + ' ' + res.data.user.lastName
            setUsersToAdd(prevUsers => {
                const combined = [...prevUsers, res.data.user];
                return Array.from(new Map(combined.map(u => [u._id, u])).values());
            });
        setSearchEmail('')
        }
        if(res.status === 404 || res.status === 400 ){
            message.error("User not found");
        }
        
        }catch(error){
            console.log("Error in searching user in view",error)
            message.error(error.response.data.message);
        }
        
    }
    const removeUserFromState = (userId) => {
        console.log("user", userId)
        setUsersToAdd(prevUsers =>
            prevUsers.filter(user => user._id.toString() !== userId.toString())
        );
    }
    
    const addUsersToLocations = async () =>{
        try {
            setLoading(true)
            const res = await BreathAPIs.addUsersToCustomerLocation(usersToAdd, selectedCustomerLocations)
            if(res.status === 200){
                message.success("Added Successfully")
                setAddUserModalVisible(false) 
                fetchUserData();
            }
            setLoading(false)
            setUsersToAdd([]);
            setSelectedCustomerLocations([]);
        } catch (error) {
            setUsersToAdd([]);
            setSelectedCustomerLocations([]);
            setLoading(false)
            message.error("Something went wrong. Please try again")
        }
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            // fixed: 'left',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        ...(props.company ? [{
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
        }] : []),
        {
            title: 'Locations',
            key: 'location',
            dataIndex: 'location',
            render: (_, record) => (

                <>
                    {record.location.map(loc => {
                        let color = 'blue';
                        return (
                            <Tag color={color} key={loc._id}>
                                <div className={styles['location-tag']}>
                                    {`${loc.locationName} - ${loc.codeId}`}<RiDeleteBin5Line
                                        onClick={
                                            () =>
                                            // removeUserLocation(record.key, loc._id)
                                            {
                                                setModalData({ userKey: record.key, locationId: loc._id, userName: record.name, location: loc.locationName });
                                                setDeleteModal(true)
                                            }
                                        } 
                                        />
                                </div>
                            </Tag>
                        );
                    })}
                </>
            ),
        },

    ];

    const addUserColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Remove',
            key: 'remove',
            render: (_, record) => (
                <Space size="middle">
                    <RiDeleteBin5Line onClick={()=>removeUserFromState(record._id)} className={styles['delete-icon-add-user']}/>
                </Space>
            ),
        },
    ]
const userData = users?.map(user => ({
    key: user._id,
    name: user.firstName + ' ' + user.lastName,
    email: user.email,
    phone: user.phone,
    company: user.company,
    location: user.location|| [],
}))


  return (
      <Container>
          {
            (propsLoading) ? 
            ( <div className={styles.spinner}>
                        <FontAwesomeIcon icon={faBolt} size="3x" />
                    </div>)
            :
              (permissions.includes('userControl') ?
                  <>
                      <div className={styles['user-view-filter-container']}>
                          <Form layout={'vertical'} >
                              <div className={styles['filter']}>
                                  <div className={`${styles['filter-left']} ${styles['filter-left-customer']}`}>
                                      <Input  value={filterText} placeholder='Search: Email, First Name, Last Name, Contact' onChange={(e) => setFilterText(e.target.value)} />
                                      <Select
                                            showSearch
                                            maxTagCount={3}
                                            mode='multiple'
                                            // defaultValue="Select Location"
                                            placeholder={'Select Location'}
                                            style={{ width: '100%' }}
                                            value={filterLocation}
                                            onChange={(value) => { setFilterLocation(value) }}
                                            //onSearch={onSearch}
                                            allowClear
                                            options={customerLocations.map(element => ({
                                            value: element._id,
                                            label: element.locationName
                                            }))}
                                            onClear={() => setFilterLocation([])}
                                            filterOption={(input, option) => 
                                            option.label.toLowerCase().includes(input.toLowerCase()) // Custom filtering logic
                                            }
                                        />
                                  </div>
                                  <div className={`${styles['filter-right']} ${styles['filter-right-customer']}`}>
                                      <Button onClick={() => { fetchUserData() }} type="primary">Filter</Button>
                                      <Button onClick={handleClearFilter} className={styles['custom-btn']} type="primary" danger color='white'> Clear</Button>
                                  </div>
                              </div>
                          </Form>
                          <Button className={styles['add-user-btn-customer-view']} onClick={() => handleAddUser()}> Add User</Button>
                      </div>
                      <div>
                          <Table
                              loading={loading}
                              columns={columns}
                              dataSource={userData}
                              onChange={handleTableChange}
                              pagination={pagination}
                              bordered
                              scroll={{ x: 'calc(600px + 50%)' }}
                          />
                      </div>

                      <Modal
                          open={addUserModalVisible}
                          onCancel={() => { setAddUserModalVisible(false); setUsersToAdd([]); setSearchEmail(''); setSelectedCustomerLocations([]) }}
                          footer={null}
                      >

                          Add Users to location
                          {/* Seaarch for user based on email [array of user ids]*/}
                          <div className={styles['add-user-modal-search-container']}>
                              <Input value={searchEmail} placeholder='Search: Email' onChange={(e) => setSearchEmail(e.target.value)} />
                              <Button onClick={() => filterUser()} disabled={searchEmail.length === 0}>Add</Button>

                          </div>

                          <Table
                              columns={addUserColumns}
                              dataSource={usersToAdd}
                              scroll={{ x: 'calc(200px + 50%)' }}
                          >
                          </Table>
                          {/* Select the location to add to [multiselect possible]*/}
                          <div>
                              {console.log("customerLocations", customerLocations)}
                              <span>Select Locations</span>
                              <Select
                                  placeholder='Select location'
                                  style={{ minWidth: "100%" }}
                                  options={customerLocations.map((element) => ({
                                      value: element._id,
                                      label: element.locationName + ' - ' + element.codeId,
                                  }))}
                                  value={selectedCustomerLocations ? selectedCustomerLocations : []}
                                  mode="multiple"
                                  allowClear
                                  onChange={(value) => {
                                      setSelectedCustomerLocations(value)
                                  }}
                                  onClear={() => setSelectedCustomerLocations([])}
                              />
                          </div>
                          <Button
                              className={styles['save-btn-add-user']}
                              disabled={selectedCustomerLocations.length === 0 || usersToAdd.length === 0}
                              onClick={() => {
                                  addUsersToLocations()
                              }}
                          >
                              {loading ? <>Saving <Spin indicator={<LoadingOutlined spin />} size="small" /></> : "Save"}
                          </Button>
                      </Modal>

                          {
                              deleteModal &&
                              <Modal
                                  open={deleteModal}
                                  onCancel={() => setDeleteModal(false)}
                                  title="Remove User from Location"
                                  okText="Remove"
                                  cancelText="No"
                                  okButtonProps={{
                                          danger: true,
                                      }}
                                onOk={()=>removeUserLocation(modalData.userKey, modalData.locationId)}
                              >
                                  Are you sure you want to remove <strong>{modalData.userName}</strong> from <strong>{modalData.location}</strong>?

                              </Modal>
                          }
                      </>
                      :
                 ( !loading && <div className={styles['restricted']}>Restricted area !</div>)
                
                )
          }
      </Container>
  )
}

CustomerUserView.propTypes = {
    user: PropTypes.string,
    type: PropTypes.string,
    customerLocation: PropTypes.array,
    userId: PropTypes.string
};

const mapStateToProps = (state) => ({
    user: state.auth && state.auth.user ? state.auth.user.firstName : null,
    type: state.auth && state.auth.user ? state.auth.user.type : null,
    userGroups : state.auth && state.auth.user ? state.auth.user.userGroups : null,
    customerLocations: state.auth && state.auth.user ? state.auth.user.customerLocation : null,
    userId: state.auth && state.auth.user ? state.auth.user._id : null,
    company: state.auth && state.auth.user ? state.auth.user.company : null

});


export default connect(mapStateToProps, {})(CustomerUserView)
